<template>
  <b-modal
    :id="this.$attrs.id"
    v-model="isVisible"
    title="Replace shipment data"
    size="lg"
    @show="loadData"
  >
    <div
      v-if="loading"
      class="text-center py-3"
    >
      <b-spinner />
    </div>
    <div v-else>
      <div>
        <validation-observer ref="replaceData">
          <b-form-group
            label="Field to replace"
            label-for="replace_field"
          >
            <b-form-select
              id="replace_field"
              v-model="replace_field"
              :options="replace_fields"
              placeholder="Choose field to replace"
              :disabled="loadingData"
            />
          </b-form-group>
          <b-form-group
            label="Search for value"
            label-for="find_value"
          >
            <b-form-input
              id="find_value"
              v-model="find_value"
              placeholder="Search for value"
              autocomplete="off"
            />
          </b-form-group>
          <b-form-group
            label="Replace to"
            label-for="replace_value"
          >
            <b-form-input
              id="replace_value"
              v-model="replace_value"
              placeholder="Replace to"
              autocomplete="off"
            />
          </b-form-group>
        </validation-observer>
      </div>
    </div>

    <template #modal-footer="{ close }">
      <b-col>
        <b-button
          variant="secondary"
          class="mr-2"
          @click="close"
        >
          Cancel
        </b-button>
      </b-col>
      <b-col
        class="text-right"
      >
        <b-button
          variant="primary"
          :disabled="isConfirmDisabled"
          @click="submit()"
        >
          Confirm
        </b-button>
      </b-col>
    </template>
  </b-modal>
</template>
<script>
import { BButton, BCol, BFormGroup, BFormInput, BFormSelect, BModal, BSpinner } from 'bootstrap-vue'
import handleError from '@/views/components/errorHandler'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver } from 'vee-validate'
import { EventBus } from '@core/utils/utils'
import { required } from '@core/utils/validations/validations'

export default {
  components: {
    ValidationObserver,
    BCol,
    BButton,
    BFormInput,
    BFormSelect,
    BFormGroup,
    BModal,
    BSpinner,
  },
  props: {
    shipment: {
      type: Object,
      required: true,
    },
    declarations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isVisible: false,
      loading: false,
      loadingData: false,
      replace_field: null,
      find_value: '',
      replace_fields: [],
      replace_value: '',
    }
  },
  computed: {
    required() {
      return required
    },
    isConfirmDisabled() {
      return this.replace_field === null
    },
  },
  methods: {
    loadData() {
      this.loading = true
      this.loadingData = true
      this.getFieldsData()
    },
    getFieldsData() {
      this.$http.get(`/v1/shipments/${this.shipment.id}/declarations/replace-data-fields`)
        .then(response => {
          this.loadingData = false
          this.loading = false
          this.replace_fields = [{
            value: null,
            text: '----select----',
          }]
          this.replace_fields = this.replace_fields.concat(response.data.data.map(replaceField => ({
            value: replaceField.field,
            text: replaceField.name,
          })))
        })
    },
    submit() {
      this.$http.post(`/v1/shipments/${this.shipment.id}/declarations/replace-data`, {
        replace_field: this.replace_field,
        find_value: this.find_value,
        replace_value: this.replace_value,
        declarationIds: this.declarations,
      })
        .then(() => {
          this.replace_field = null
          this.find_value = ''
          this.replace_value = ''
          this.isVisible = false

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Replacing field data',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          EventBus.$emit('renewDeclarationList')
          EventBus.$emit('refresh-statistics')
        })
        .catch(error => {
          handleError(error, this.$toast)
        })
    },
  },
}
</script>
